/*
This module contains utilities for form and form fields that are shared across multiple field types.
*/

/**
 * Generate a UUID v4 using the native crypto API when available,
 * Using the native browser web API to generate a UUID v4 string.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/randomUUID
 *
 * @returns A UUID v4 string
 */
export const generateUuidV4 = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  throw new Error('Crypto API not available');
};
